export const LOW_ERRORS_MAP = {
  spell_error: {
    name: '拼写检查',
    shortName: '拼写问题',
    track: {
      scene_type: 'CheackWords',
      event_name: '查看拼写低错检查内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackWords_click',
    },
  },
  punctuation_error: {
    name: '标点检查',
    shortName: '标点问题',
    track: {
      scene_type: 'CheackPunctuation',
      event_name: '查看标点检查低错内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackPunctuation_click',
    },
  },
  space_error: {
    name: '空格检查',
    shortName: '空格问题',
    track: {
      scene_type: 'CheackSpace',
      event_name: '查看空格检查低错内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackSpace_click',
    },
  },
  miss_error: {
    name: '漏译检查',
    shortName: '漏译问题',
    track: {
      scene_type: 'CheackOmit',
      event_name: '查看漏译检查低错内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackOmit_click',
    },
  },
  grammar_error: {
    name: '语法检查',
    shortName: '语法问题',
    track: {
      scene_type: 'CheackGram',
      event_name: '查看语法检查低错内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackGram_click',
    },
  },
  case_error: {
    name: '大小写检查',
    shortName: '大小写问题',
    track: {
      scene_type: 'CheackUPdown',
      event_name: '查看大小写检查低错内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackUPdown_click',
    },
  },
};

export const UNIFORM_ERRORS_MAP = {
  lowCheck: {
    name: '低错检查',
    shortName: '低错',
    track: {
      scene_type: 'ShowLowerro',
      event_name: '展开智能QA低错内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_ShowLowerro_click',
    },
  },
  unUsedTerm: {
    name: '术语缺失检查',
    shortName: '术语缺失',
    track: {
      scene_type: 'CheackTerm',
      event_name: '查看术语缺失内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackTerm_click',
    },
  },
  highTerm: {
    name: '高频词一致性检查',
    shortName: '高频词',
    track: {
      scene_type: 'CheackHighfluent',
      event_name: '查看高频词不一致内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackHighfluent_click',
    },
  },
  highSimilar: {
    name: '高相似句一致性检查',
    shortName: '相似句',
    track: {
      scene_type: 'CheackSimilari',
      event_name: '查看高相似句子内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackSimilari_click',
    },
  },
  highCritical: {
    name: '重点位置句子检查',
    shortName: '重点位置',
    track: {
      scene_type: 'CheackKeypoint',
      event_name: '查看重点位置句子内容',
      event_type: 'click',
      event_code: 'CopilotWorkbench_CheackKeypoint_click',
    },
  },
};
